/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Parq_SavedInputs */

const en_us2_profile_editors_parq_saved = /** @type {(inputs: Profile_Editors_Parq_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionnaire updated`)
};

const pt_br2_profile_editors_parq_saved = /** @type {(inputs: Profile_Editors_Parq_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionário atualizado`)
};

const es_419_profile_editors_parq_saved = /** @type {(inputs: Profile_Editors_Parq_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuestionario actualizado`)
};

const pt_pt2_profile_editors_parq_saved = /** @type {(inputs: Profile_Editors_Parq_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionário atualizado`)
};

const fr_fr2_profile_editors_parq_saved = /** @type {(inputs: Profile_Editors_Parq_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionnaire mis à jour`)
};

const de_de2_profile_editors_parq_saved = /** @type {(inputs: Profile_Editors_Parq_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragebogen aktualisiert`)
};

const it_it2_profile_editors_parq_saved = /** @type {(inputs: Profile_Editors_Parq_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionario aggiornato`)
};

/**
* | output |
* | --- |
* | "Questionnaire updated" |
*
* @param {Profile_Editors_Parq_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_parq_saved = /** @type {((inputs?: Profile_Editors_Parq_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Parq_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_parq_saved(inputs)
	if (locale === "es-419") return es_419_profile_editors_parq_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_parq_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_parq_saved(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_parq_saved(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_parq_saved(inputs)
	return en_us2_profile_editors_parq_saved(inputs)
});
export { profile_editors_parq_saved as "profile-editors.parq_saved" }